import React from "react";

const ThermoSvg = (props) => (
  <svg
    style={{ margin: "0px", padding: "0px", height: "90px", width: "200px" }}
  >
    <svg
      height="auto"
      version="1.1"
      viewBox="0 0 60 60"
      width="300px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title />
      <desc />
      <defs />
      <text
        x="4"
        y="10"
        font-family="Verdana"
        font-size="6"
        font-weight="normal"
        fill={props.textColor}
      >
        {props.name}
      </text>
      <g
        fill="none"
        fill-rule="evenodd"
        id="Thermometer-Hot"
        stroke="none"
        stroke-width="1"
        transform="translate(18,15)"
      >
        <g
          id="Group"
          stroke="#979797"
          stroke-width="2"
          transform="translate(7.000000, 2.000000)"
        >
          <path
            d="M3,16.8026932 L3,3 C3,1.34314575 4.34314575,3.04359188e-16 6,0 C7.65685425,-3.04359188e-16 9,1.34314575 9,3 L9,16.8026932 C10.7934041,17.8401214 12,19.7791529 12,22 C12,25.3137085 9.3137085,28 6,28 C2.6862915,28 0,25.3137085 0,22 C0,19.7791529 1.20659589,17.8401214 3,16.8026932 Z"
            id="Combined-Shape"
          />
          <path d="M13,5 L18,5" id="Path-19" stroke-linecap="round" />
          <path d="M13,9 L18,9" id="Path-20" stroke-linecap="round" />
          <path d="M13,13 L18,13" id="Path-21" stroke-linecap="round" />
        </g>
        <g fill="red" id="Group-2" transform="translate(10.000000, 12.000000)">
          <circle cx="3" cy="12" id="Oval" r="3" />
          <rect height="11" id="Rectangle-2" rx="1" width="2" x="2" y="0" />
        </g>
      </g>
    </svg>
  </svg>
);
export default ThermoSvg;
